export function MailingListListLayout() {
  return (
    <div>
      <p>No mailing lists found.</p>
    </div>
  );
}
